export const initialToolbar = {
  size: false,
  align: false,
  color: false,
  list: false,
  blockquote: false,
  codeblock: false,
  link: false,
  file: false,
  html: false,
  image: true,
  emoji: false,
  video: true,
};
